module.exports = __webpack_public_path__ + "img/img0.265abb38.jpg";